/** store.js
  アプリケーションの状態を管理する vuex の管理をする
  @see {@link https://vuex.vuejs.org/ja/intro.html}
*/
import Vuex from 'vuex'
import Vue from 'vue'

import State from './state'
import Getters from './getters'
import Mutations from './mutations'
import Actions from './actions'
Vue.use(Vuex)

const state = State
const getters = Getters
const mutations = Mutations
const actions = Actions

export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store.js